/**
 * Returns TRUE if all of the values match the test value.
 */
export function allValues(obj, testValue) {
    return Object.values(obj).every(v => v === testValue);
}

/**
 * Returns TRUE if at least one of the values match the test value.
 */
export function anyValue(obj, testValue) {
    return Object.values(obj).some(v => v === testValue);
}
